export default "__VITE_ASSET__Del7FMnD__"